import { useState } from 'react';
import { login } from '@/lib/auth';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center px-4">
      <div className="w-full max-w-[360px]">
        <div className="flex flex-col items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-lg bg-[#007A7A] flex items-center justify-center font-display font-bold text-xl text-white">
            VD
          </div>
          <div className="text-center">
            <h1 className="font-display font-bold text-xl tracking-tight">VyraDash</h1>
            <p className="text-[0.72rem] text-text-muted uppercase tracking-widest mt-0.5">
              Engineering Quality Dashboard
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="bg-bg-surface border border-border rounded-lg p-6">
          <label
            htmlFor="email"
            className="block text-[0.78rem] font-medium text-text-secondary mb-1.5"
          >
            Email
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-field mb-4"
            placeholder="you@vyralab.com"
            autoFocus
            autoComplete="email"
          />

          <label
            htmlFor="password"
            className="block text-[0.78rem] font-medium text-text-secondary mb-1.5"
          >
            Password
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-field mb-4"
            placeholder="Enter password"
            autoComplete="current-password"
          />

          {error && (
            <div className="text-[0.75rem] text-danger mb-3 bg-danger-soft rounded px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !email || !password}
            className="w-full py-2 px-4 rounded-md bg-accent text-white text-[0.82rem] font-semibold transition-all hover:bg-accent-bright disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-center text-[0.65rem] text-text-muted mt-6">
          Vyralab Internal · Authorized Access Only
        </p>
      </div>
    </div>
  );
}
